import { gql } from 'graphql-request';

const PrimaryCollectionFragment = gql`
  id
  title
  canonicalSlug
  resourceType
  templateName
  results(pageSize: 4) {
    items {
      subtitle
      title
      resourceType
      canonicalSlug
      canonicalUrl
      publishDate
      collectionRelatedLinks {
        url
        title
        prefix
      }
    }
  } 
`;

export default PrimaryCollectionFragment;
